import React from "react";
import Link from "../../components/Link";
import Media from "../../components/common/Media";
import { styled } from "../../stitches.config";
import CategoryBadge from "../CategoryBadge";
import { bodyLarge, body, h3 } from "../commonStyles/Fonts";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
interface PhotoOnLeftProps {
    image: string;
    article?: any;
    showDate?: boolean;
}
const PhotoOnLeft: React.FC<PhotoOnLeftProps> = ({
    image,
    article,
    showDate,
}) => {
    const showSkeleton = article.url ? false : true;

    return (
        <StyledPhotoOnLeft data-tb-region-item>
            <Link to={article.url}>
                <StyledImage>
                    <Media
                        // media={media}
                        src={image || article?.picture?.img}
                        preserveRatio={false}
                        aspectRatio={1.5}
                        width={300}
                        height={200}
                        alt={article?.picture?.alt}
                        title={article?.picture?.title}
                    />
                    {article?.category?.name && (
                        <BadgeWrapper>
                            {showSkeleton ? <Skeleton /> : <CategoryBadge text={article.category.name} />}

                        </BadgeWrapper>
                    )}
                </StyledImage>
                <TextWrapper>
                    {showDate &&
                        <Date>
                            <time dateTime={article.iso_date}>
                                {article.date}
                            </time>
                        </Date>
                    }
                    <Title className={h3()}>{showSkeleton ? <Skeleton count={3} /> : article?.title}</Title>
                    <Lead>
                        {showSkeleton ? <Skeleton count={3} /> : article?.lead}
                    </Lead>
                </TextWrapper>
            </Link>
        </StyledPhotoOnLeft>
    );
};
const StyledImage = styled("div", {
    flexShrink: 0,
    position: "relative",
    minWidth: "300px",
    minHeight: "200px",
    "& img": {
        objectFit: "cover",
        width: "100%",
    },
});
const BadgeWrapper = styled("span", {
    display: "none",
    "@bp4": {
        display: "block",
        position: "absolute",
        bottom: "16px",
        left: "16px",
        zIndex: 3,
    },
});
const Lead = styled("p", {
    display: "none",
    "> span": {
        textDecoration: "none",
    },
    "@bp4": {
        display: "block",
        padding: 0,
        margin: "8px 0 0 0",
        fontWeight: "600",
        fontFamily: "$grotesk",
        lineHeight: "24px",
        maxHeight: "72px",
        overflow: "hidden",
    },
});
const Date = styled("p", {
    padding: 0,
    fontFamily: "$grotesk",
    margin: "0 0 8px 0",
    fontWeight: "600",
    color: "$grayscale75",
    textDecoration: "none !important",
    fontSize: 16,
    lineHeight: "20px",
    letterSpacing: "0px",
});
const TextWrapper = styled("div", {
    color: "$grayscale100",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "16px",
    width: "100%",
});
const StyledPhotoOnLeft = styled("div", {
    "& a": {
        width: "100%",
        display: "flex",
        flexDirection: "row",
    },
});
const Title = styled("p", {
    padding: 0,
    margin: 0,
    fontFamily: "$grotesk",
    fontSize: 16,
    lineHeight: "24px",
    letterSpacing: "0px",
    fontWeight: "600",
    color: "$grayscale100",
    textDecoration: "none !important",
    "@bp4": {
        fontSize: 24,
        lineHeight: "30px",
        letterSpacing: "0.2px",
        fontWeight: "700",
    },
});

export default PhotoOnLeft;
